import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "./stores/authStore";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import MapPage from "./pages/MapPage";
import PlansPage from "./pages/PlansPage";
import PlanPage from "./pages/PlanPage";
import OrganizationPage from "./pages/OrganizationPage";
import ReportingPage from "./pages/ReportingPage";

function ProtectedRoute({
  children,
  requireAdmin = false,
  requireOrgAdmin = false,
}: {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireOrgAdmin?: boolean;
}) {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && user?.role !== "admin") {
    return <Navigate to="/map" replace />;
  }

  if (requireOrgAdmin) {
    const orgRole = user?.organization?.orgRole;
    if (orgRole !== "owner" && orgRole !== "admin") {
      return <Navigate to="/map" replace />;
    }
  }

  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/map" replace />} />
          <Route path="map" element={<MapPage />} />
          <Route path="plans" element={<PlansPage />} />
          <Route path="plan/:id" element={<PlanPage />} />
          <Route
            path="reporting"
            element={
              <ProtectedRoute requireOrgAdmin>
                <ReportingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="organization"
            element={
              <ProtectedRoute requireOrgAdmin>
                <OrganizationPage />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
